(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/icon-brand/views/icon_brand_partial.js') >= 0) return;  svs.modules.push('/components/ui/icon-brand/views/icon_brand_partial.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.ui=_svs.ui||{};
_svs.ui.icon_brand=_svs.ui.icon_brand||{};
_svs.ui.icon_brand.partials=_svs.ui.icon_brand.partials||{};
svs.ui.icon_brand.partials.icon_brand = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = (helpers.compare || (depth0 && depth0.compare) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.size : depth0),"!=","xs",{"name":"compare","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var helper;

  return "-"
    + container.escapeExpression(((helper = (helper = helpers.size || (depth0 != null ? depth0.size : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"size","hash":{},"data":data}) : helper)));
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing;

  return "<i class=\"icon-brand"
    + ((stack1 = (helpers.isDefined || (depth0 && depth0.isDefined) || alias2).call(alias1,(depth0 != null ? depth0.size : depth0),{"name":"isDefined","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " icon-brand-"
    + container.escapeExpression(((helper = (helper = helpers.brand || (depth0 != null ? depth0.brand : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"brand","hash":{},"data":data}) : helper)))
    + "\"></i>";
},"useData":true});
Handlebars.partials['ui-icon-brand-icon_brand'] = svs.ui.icon_brand.partials.icon_brand;
})(svs, Handlebars);

 })(window);